import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: cron.Progress.
export default class Progress extends Fragment {
  declare [Type]: 'cron/progress';

  @attr('string', { defaultValue: '' })
  declare currentItem: string;

  @attr('number', { defaultValue: 0 })
  declare currentItemNum: number;

  @attr('number', { defaultValue: 0 })
  declare totalNumItems: number;

  @attr('number', { defaultValue: 0 })
  declare numFailures: number;
}
